<template>
  <div class="settings-global">
    <div class="tw-text-lg tw-font-medium tw-border-b-4 tw-border-nj-primary tw-w-48 tw-text-gray-700">Login</div>
  </div>
</template>
<script>
export default {
  name: 'SettingsGlobal',
}
</script>